import { Table, TableRow, WidthType, TableLayoutType } from "docx";
import Options from "../../../data/options";
import { tableCellHeader, tableCellHeaderColspan } from "../results/tableCell";
export const secondTable = (user, klausur, schueler, companies) => {
  const companyName = companies.find(
    (c) => c.id === parseInt(klausur.companyId)
  )?.name;

  return new Table({
    layout: TableLayoutType.FIXED, // Layout auf "fixed" setzen
    columnWidths: [3000, 7000],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        children: [
          tableCellHeaderColspan(
            `${Options.getValue(
              "pruefungsart",
              klausur.pruefungsart
            )} ${klausur.date.slice(0, 4)}, ${Options.getValue(
              "kursart",
              klausur.kursart
            )} ${Options.getValue("fach", klausur.fach)}`,
            2
          ),
        ],
      }),
      new TableRow({
        children: [
          tableCellHeader("Kurs-/ Schulhalbjahr"),
          tableCellHeader(`${Options.getValue("halbjahr", klausur.halbjahr)}`),
        ],
      }),
      new TableRow({
        children: [tableCellHeader(""), tableCellHeader("")],
      }),
      new TableRow({
        children: [
          tableCellHeader("Kursleitung:"),
          tableCellHeader(`${user.firstName} ${user.lastName}`),
        ],
      }),
      new TableRow({
        children: [
          tableCellHeader("Schule:"),
          tableCellHeader(`${companyName}`),
        ],
      }),
    ],
  });
};
